import { track } from '@eventbrite/datalayer-library';
import { AlertChunky as AlertChunkySvg } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { HEAP_SOFT_ACCOUNT_VERIFY_PASSWORD_MODAL_SHOWN_EVENT } from '../../constants/analytics';
import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../../constants/status';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import AuthDialogWithExpiration from '../common/AuthDialogWithExpiration';
import PageHeader from '../common/Header';
import './SoftAccountStatusContent.scss';

const SoftAccountStatusContent = () => {
    const frontendContext: IFrontendContext = useFrontendContext();
    const userContext: IUserContext = useUserContext();
    const configContext: IConfigContextProps = useConfigContext();
    const isReferrerMyTickets = decodeURIComponent(
        configContext?.referrer ?? '',
    ).includes('/mytickets');

    const email = userContext?.state.lookup.lookedAccount ?? '';
    const softAccountEmailStatus = frontendContext.state.softAccountEmailStatus;

    const componentClasses = classNames(
        'eds-l-mar-vert-14',
        'soft-account-status-content',
    );

    let titleText = isReferrerMyTickets
        ? gettext("Let's verify your account")
        : gettext('Never lose your tickets');

    let subtitleText = isReferrerMyTickets
        ? gettext(
              'We sent a link to <strong>%(email)s</strong> to activate your account and get your tickets.',
              { email },
          )
        : gettext(
              'We sent a link to <strong>%(email)s</strong> to add a password to your account.',
              { email },
          );

    let softComponent = (
        <AuthDialogWithExpiration
            titleText={titleText}
            subtitleText={subtitleText}
            noWrapperStyles={true}
            isReferrerMyTickets={isReferrerMyTickets}
        />
    );

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.

    if (softAccountEmailStatus === SOFT_ACCOUNT_EMAIL_STATUSES.failed) {
        titleText = gettext('There has been an error');
        subtitleText = gettext('Please try again later');
        softComponent = (
            <div className="eds-align--center">
                <PageHeader
                    iconColor="ui-700"
                    iconType={<AlertChunkySvg />}
                    titleText={titleText}
                    titleClassName="eds-text-hs eds-l-mar-bot-3"
                    subtitleText={subtitleText}
                />
            </div>
        );
    }

    useEffect(() => {
        track({
            eventName: HEAP_SOFT_ACCOUNT_VERIFY_PASSWORD_MODAL_SHOWN_EVENT,
            eventData: {},
        });
    }, []);

    return <div className={componentClasses}>{softComponent}</div>;
};

export default SoftAccountStatusContent;
